import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LoginSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LoginSVG;
